import { Box, Button, ButtonProps, Popover, StatusIndicator, StatusIndicatorProps } from '@amzn/awsui-components-react-v3';
import React, { useState } from 'react';
import { copyToClipboard } from './copyToClipboardUtils';

const SUCCESS_STATUS : StatusIndicatorProps.Type = 'success';
const ERROR_STATUS : StatusIndicatorProps.Type = 'error';

interface CopyToClipboardPros {
  copyText: string,
  copyButtonLabel: string,
  successText: string,
  errorText: string,
  variant: ButtonProps.Variant,
}

export default function CopyToClipboard({ copyText, copyButtonLabel, successText, errorText, variant} : CopyToClipboardPros) {
  const [status, setStatus] = useState(SUCCESS_STATUS);
  const [message, setMessage] = useState(successText);

  return (
    <div className="custom-wrapping">
      <Box margin={{ right: 'xxs' }} display="inline-block">
        <Popover
          size="small"
          position="top"
          dismissButton={false}
          triggerType="custom"
          content={<StatusIndicator type={status}>{message}</StatusIndicator>}
        >
          <Button
            variant={variant}
            iconName="copy"
            ariaLabel={copyButtonLabel}
            onClick={() => {
              copyToClipboard(copyText).then(
                () => {
                  setStatus(SUCCESS_STATUS);
                  setMessage(successText);
                },
                () => {
                  setStatus(ERROR_STATUS);
                  setMessage(errorText);
                }
              );
            }}
          >{copyButtonLabel}</Button>
        </Popover>
      </Box>
      {variant==="normal" ? <></> :copyText}
    </div>
  );
}